var HUMAN_TYPING_SPEED = 95;
export { HUMAN_TYPING_SPEED };